import React from 'react';
import {
  Datagrid,
  TextInput,
  Resource,
  TextField,
  Filter as RAFilter,
  EditButton,
  NullableBooleanInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  useGetMany,
  FormTab,
} from 'react-admin';
import { AppCreate, AppEdit, AppList, AppTabbedForm } from 'components/CRUD';
import Icon from '@material-ui/icons/Tune';
import { Box, Button, Link, Paper, Typography } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const Filter = props => (
  <RAFilter {...props}>
    <TextInput source="name" alwaysOn />
    <NullableBooleanInput source='enabled' alwaysOn />
    <TextInput source="auth0.organizationId" label="Org ID" alwaysOn />
  </RAFilter>
);

export const List = props =>  (
  <AppList {...props} filters={<Filter />}>
    <Datagrid>
      <TextField source='name' />
      <TextField source='key' label='Customer Key' />
      <EditButton />
    </Datagrid>
  </AppList>
);

const Primary = (props) => {
  return (
    <Box width='100% !important' display='flex'>
      <Box width={0.3} display='flex' flexDirection={'column'} p={2}>
        <Box width={1} display='flex'>
          <TextInput source='name' fullWidth/>
        </Box>
        <Box width={1} display='flex' >
          <ReferenceArrayInput fullWidth perPage={1000} sort={{field: 'name', order: 'ASC'}} reference='ManagementService' source='activatedServices'>
            <AutocompleteArrayInput optionText='name' /> 
          </ReferenceArrayInput>
        </Box>
      </Box>
      <Box width={0.7} display='flex' flexDirection={'column'} p={2}>
        <Paper>
          <Box p={2}>
            <Typography variant='h4'>Auth0 Config</Typography>
            {props?.record?.auth0?.organizationId && (
              <Button variant='contained'>
                <Link target='_blank' href={`https://manage.auth0.com/dashboard/us/panoscape/organizations/${props?.record?.auth0?.organizationId}/overview`}>Auth0 Management</Link>
              </Button>
            )}
            <TextInput disabled fullWidth source='auth0.organizationId' label='Org Id' />
          </Box>
        </Paper>
        <Paper>
          <Box p={2}>
            <Typography variant='h4'>Database Config</Typography>
            <TextInput source='settings.database' fullWidth disabled label='Database'/>
          </Box>
        </Paper>
        <Paper>
          <Box p={2}>
            <Typography variant='h4'>Azure Config</Typography>
            <TextInput disabled fullWidth source='azure.storage.cdnHost' label='CDN Host' />
            <TextInput disabled fullWidth source='azure.storage.cdnToken' label='CDN Token' />
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}

const Users = (props) => {
  const rawUsers = props?.record?.users?.map(row => row?.id) || [];
  
  const {data: users} = useGetMany('User', rawUsers);

  return (
    <Box width='100% !important' display='flex' flexDirection='column'>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Id</TableCell>
              <TableCell>Email</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users?.map((row) => {
              if (!row?.id) {
                return null;
              }

              return (
                <TableRow key={row?.id}>
                  <TableCell component="th" scope="row">
                    {row?.id}
                  </TableCell>
                  <TableCell>{row?.email}</TableCell>
                  <TableCell align="right">
                    <Button variant='contained'>
                      <Link target='_blank' href={`https://manage.auth0.com/dashboard/us/panoscape/users/${row?.id}`}>Edit User</Link>
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}


export const Edit = props => (
  <AppEdit {...props} undoable={false}>     
    <AppTabbedForm formAction='edit' warnWhenUnsavedChanges>
      <FormTab label='General'>
        <Primary edit {...props} />
      </FormTab>
      <FormTab label='Users'>
        <Users edit {...props} />
      </FormTab>
    </AppTabbedForm>
  </AppEdit>
);

export const Create = props => {
  return (
    <AppCreate {...props} undoable={false}>      
      <AppTabbedForm formAction='edit' warnWhenUnsavedChanges>
        <FormTab label='General'>
          <Primary edit {...props} />
        </FormTab>
        <FormTab label='Users'>
          <Users edit {...props} />
        </FormTab>
      </AppTabbedForm>
    </AppCreate>
  );
}

const Admin = () => <Resource name="Customer" options={{label: 'Customers'}} create={Create} list={List} edit={Edit} icon={Icon} />;

export default Admin;